import { ViewContainerRef } from '@angular/core';

import { createProviderToken } from '@core/common-legacy';

export interface ReportsMoveDialogService {
  openMoveDialog: (params: {
    dashboardId: number;
    componentId: number | string;
    viewContainerRef?: ViewContainerRef;
  }) => void;
}

export const { inject: injectReportsMoveDialog, provide: provideReportsMoveDialog } =
  createProviderToken<ReportsMoveDialogService>('ReportsMoveDialogService')();
